import { isbot } from "isbot";
import { AuthenticationContextProps } from "~/contexts/authenticationContext";

export const shouldTriggerAnalytics = (args: {
  auth?: Partial<AuthenticationContextProps> | null;
  userAgent?: string | null;
}): boolean => {
  const isNotInternalEmployee = args.auth?.isVendrInternalEmployee !== true;
  const isNotSyntethicTest = args.auth?.isSyntheticTest !== true;
  const organizationTriggersAnalytics =
    args.auth?.identity?.triggersAnalytics ?? true;
  const isBot = args.userAgent && isbot(args.userAgent);

  return (
    isNotInternalEmployee &&
    isNotSyntethicTest &&
    organizationTriggersAnalytics &&
    !isBot
  );
};
